<template><div><h2 id="with-default-styling" tabindex="-1" class="d-docsite--header-2">With Default Styling <a class="header-anchor d-link d-docsite--link d-link" href="#with-default-styling" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">By default, item layout includes custom styling, like paddings, sizes, colors, etc.</p>
<code-well-header class="d-d-block">
<dt-item-layout>
  <template #left>
      <dt-icon name="lock" />
    </template>
    Layout title
    <template #subtitle>
      Subtitle
    </template>
    <template #bottom>
      <dt-badge>Content</dt-badge>
    </template>
    <template #right>
      <dt-icon name="share" />
    </template>
    <template #selected>
      <dt-icon name="check" />
    </template>
</dt-item-layout>
</code-well-header>
<code-example-tabs
htmlCode='
<div class="d-item-layout">
  <section class="d-item-layout--left">
    <svg>...</svg>
  </section>
  <section class="d-item-layout--content">
    <div class="d-item-layout--title">
      Layout title
    </div>
    <div class="d-item-layout--subtitle d-item-layout--subtitle--with-title">
      Subtitle
    </div>
    <div class="d-item-layout--bottom">
      <span class="d-badge">
        <span class="d-badge__label">Content</span>
      </span>
    </div>
  </section>
  <section class="d-item-layout--right">
    <svg>...</svg>
  </section>
  <section class="d-item-layout--selected">
    <svg>...</svg>
  </section>
</div>
'
vueCode='
<dt-item-layout>
  <template #left>
    <dt-icon name="lock" />
  </template>
  Layout title
  <template #subtitle>
    Subtitle
  </template>
  <template #bottom>
    <dt-badge>Content</dt-badge>
  </template>
  <template #right>
    <dt-icon name="share" />
  </template>
  <template #selected>
    <dt-icon name="check" />
  </template>
</dt-item-layout>
'
showHtmlWarning />
<h2 id="without-styling" tabindex="-1" class="d-docsite--header-2">Without Styling <a class="header-anchor d-link d-docsite--link d-link" href="#without-styling" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Setting the <code v-pre>unstyled</code> property will add <code v-pre>d-item-layout--custom</code> class. This will change the item-layout from flexbox to grid, removing all the custom styling while maintaining the slots positions.</p>
<p class="d-docsite--paragraph">This way you can utilize the layout and customize your own styling using utility classes.</p>
<code-well-header class="d-d-block">
  <dt-item-layout unstyled ref="exampleUnstyled">
    <template #left>
        <dt-icon name="lock" />
      </template>
      Layout title
      <template #subtitle>
        Subtitle
      </template>
      <template #bottom>
        <dt-badge>Content</dt-badge>
      </template>
      <template #right>
        <dt-icon name="share" />
      </template>
      <template #selected>
        <dt-icon name="check" />
      </template>
  </dt-item-layout>
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.exampleUnstyled"
vueCode='
<dt-item-layout unstyled>
  <template #left>
    <dt-icon name="lock" />
  </template>
  Layout title
  <template #subtitle>
    Subtitle
  </template>
  <template #bottom>
    <dt-badge>Content</dt-badge>
  </template>
  <template #right>
    <dt-icon name="share" />
  </template>
  <template #selected>
    <dt-icon name="check" />
  </template>
</dt-item-layout>
'
/>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="itemLayout" /></div></template>


